import { associatedEntityTypesFragments } from "./QuestionBankFragment";

export const EDIT = "edit";
export const CREATE = "create";
export const QUESTION_TOPIC = "QUESTION_TOPIC";
export const QUESTION_SUB_TOPIC = "QUESTION_SUB_TOPIC";
export const QUESTION_TAG = "QUESTION_TAG";
export const SUBJECT = "SUBJECT";
export const PLANNER_ELEMENT_NODE = "PLANNER_ELEMENT_NODE";
export const GRADE = "GRADE";
export const SUBJECT_LEVEL = "SUBJECT_LEVEL";
export const QUESTION_PAPER = "QUESTION_PAPER";
export const QUESTION_LAST_MODIFIED_FORMAT = "D MMM YYYY, hh:mm a";

/** Question Status types */
export const ALL_QUESTION = "ALL_QUESTION";
export const PUBLISHED = "PUBLISHED";
export const APPROVED = "APPROVED";
export const CORRECTION_COMPLETED = "CORRECTION_COMPLETED";
export const CORRECTION_REQUIRED = "CORRECTION_REQUIRED";
export const PENDING_REVIEW = "PENDING_REVIEW";
export const DRAFT = "DRAFT";
export const ARCHIVED = "ARCHIVED";

/** Question Status Color Mapping */
export const QUESTION_STATUS_COLORS = {
  [DRAFT]: "var(--text-semantic-warning)",
  [PENDING_REVIEW]: "var(--text-semantic-warning)",
  [CORRECTION_REQUIRED]: "var(--text-semantic-warning)",
  [CORRECTION_COMPLETED]: "var(--text-semantic-warning)",
  [APPROVED]: "var(--text-semantic-success)",
  [PUBLISHED]: "var(--text-semantic-success)",
};

export const TOPIC_DEPTH = 1;
export const SUB_TOPIC_DEPTH = 2;
export const CONTENT_DEPTH = 3;
export const ORG_RESOURCE_TYPE_QUESTION_BANK = "QUESTION_BANK_RESOURCE";
export const MYP_LEARNING_OBJECTIVES = "MYP_LEARNING_OBJECTIVES";
export const MYP_OBJECTIVES = "MYP_OBJECTIVES";
export const MYP_KEY_CONCEPT = "MYP_KEY_CONCEPT";
export const MYP_GLOBAL_CONTEXT = "MYP_GLOBAL_CONTEXT";
export const MYP_RELATED_CONCEPT = "MYP_RELATED_CONCEPT";
export const MYP_LIBRARY_TOPICS = "MYP_LIBRARY_TOPICS";

export const associatedEntityTypeFragmentMapping = {
  [GRADE]: {
    typeName: "Grade",
    fragment: associatedEntityTypesFragments.gradeDetails,
    fragmentName: "gradeDetailsItem",
  },
  [SUBJECT]: {
    typeName: "Subject",
    fragment: associatedEntityTypesFragments.subjectDetails,
    fragmentName: "subjectDetailsItem",
  },
  [QUESTION_TOPIC]: {
    typeName: "GenericTag",
    fragment: associatedEntityTypesFragments.genericTagDetails,
    fragmentName: "genericTagDetailsItem",
  },
  [QUESTION_SUB_TOPIC]: {
    typeName: "GenericTag",
    fragment: associatedEntityTypesFragments.genericTagDetails,
    fragmentName: "genericTagDetailsItem",
  },
  [QUESTION_TAG]: {
    typeName: "GenericTag",
    fragment: associatedEntityTypesFragments.genericTagDetails,
    fragmentName: "genericTagDetailsItem",
  },
  [QUESTION_PAPER]: {
    typeName: "GenericTag",
    fragment: associatedEntityTypesFragments.genericTagDetails,
    fragmentName: "genericTagDetailsItem",
  },
  [SUBJECT_LEVEL]: {
    typeName: "GenericTag",
    fragment: associatedEntityTypesFragments.genericTagDetails,
    fragmentName: "genericTagDetailsItem",
  },
  [PLANNER_ELEMENT_NODE]: {
    typeName: "PlannerElementNode",
    fragment: associatedEntityTypesFragments.plannerElementNode,
    fragmentName: "plannerElementNodeItemV2",
  },
};

/** the list of keys of the filters that are specifically shown in add filters modal  */
export const questionFeedFilterModalKeys = [
  "createdBy",
  "reviewer",
  "grades",
  "subjects",
  "questionTypes",
  "paperTypes",
  "difficulty",
  "plannerElements",
  "objectives",
  "topics",
  "subtopics",
  "contents",
  "criterion",
  "keyConcepts",
  "globalContext",
  "relatedConcepts",
  "subjectLevels",
];
